import { render, staticRenderFns } from "./UserProfilePartner.vue?vue&type=template&id=ec969678&scoped=true&"
import script from "./UserProfilePartner.vue?vue&type=script&lang=js&"
export * from "./UserProfilePartner.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePartner.vue?vue&type=style&index=0&id=ec969678&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec969678",
  null
  
)

export default component.exports